import { CircularProgress } from "@mui/material"

const Loader = ({ isLoading }: any) => {
    if (isLoading) return <div className="loader"><CircularProgress /></div>
    return null
}

export default Loader